import { computed } from 'vue';
import { cn } from 'Components/primitives/utils';
export function useDialogStyles(props) {
    // `styles` has more priority than class. Since classes already define width properties, we cannot guarantee these ones to override them.
    // Applying styles through css is also not a solution since we have an access to tailwind.
    // And it can be tested now
    const dialogStyle = computed(() => {
        const style = {};
        if (!props.autoWidth) {
            const w = props.width || '80%';
            style.width = typeof w === 'number' ? `${w}px` : props.small ? '' : w;
        }
        if (props.minWidth)
            style.minWidth = typeof props.minWidth === 'number' ? `${props.minWidth}px` : props.minWidth;
        if (props.maxWidth)
            style.maxWidth = typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth;
        if (props.height)
            style.height = typeof props.height === 'number' ? `${props.height}px` : props.height;
        if (props.minHeight)
            style.minHeight = typeof props.minHeight === 'number' ? `${props.minHeight}px` : props.minHeight;
        if (props.maxHeight)
            style.maxHeight = typeof props.maxHeight === 'number' ? `${props.maxHeight}px` : props.maxHeight;
        return style;
    });
    const contentClass = computed(() => {
        if (props.autoWidth) {
            return cn('max-w-none w-[90%] md:w-[60%] xl:w-[35%]', props.small && 'md:w-[50%] xl:w-[30%]');
        }
        return 'max-w-none';
    });
    return {
        dialogStyle,
        contentClass,
    };
}
